import { useStorage } from '@vueuse/core';
import { getStorageKey, STORAGE } from '@NavigationModule';
import { OPENED_TIPS_STORAGE_KEY } from '../constants';

// NOTE :: Browser only on purpose. It just stops the pulse after the first open; losing it brings
// the pulse back, nothing else.
const openedTipKeys = useStorage<string[]>(getStorageKey(STORAGE.HELP_TIPS, OPENED_TIPS_STORAGE_KEY), []);

export default function useOpenedTips() {
  // HELPERS
  function wasTipOpened(tipKey: string) {
    return openedTipKeys.value.includes(tipKey);
  }

  // EVENTS
  function markTipOpened(tipKey: string) {
    if (wasTipOpened(tipKey)) return;

    openedTipKeys.value = [...openedTipKeys.value, tipKey];
  }

  return { markTipOpened, wasTipOpened };
}
